import { graphql } from 'react-relay/legacy';

export type {
    pdpRespMarketplacePrimaryRootQuery$variables,
    pdpRespMarketplacePrimaryRootQuery as PdpRespMarketplacePrimaryRootQueryType,
} from './__generated__/pdpRespMarketplacePrimaryRootQuery.graphql';

export const pdpRespMarketplacePrimaryRootQuery = graphql`
    query pdpRespMarketplacePrimaryRootQuery(
        $itemId: String!
        $itemIds: [String]!
        $userIds: [String]!
        $userId: String = ""
        $guestId: String = ""
        $userZipCode: String = ""
        $isTrade: Boolean = false
        $forcedCurrency: Currency
        $fetchPdp: Boolean = false
        $fetchUser: Boolean = false
        $priceBookName: String = ""
        $isMultiSku: Boolean = false
        $followSearchPages: [String]
        $userCountryCode: String = ""
        $afterDisplay: Boolean = false
        $personalizationId: String = ""
        $afterDisplayOrBuaSsr: Boolean = false
        $isInteractivePdpChat: Boolean = false
        $isPDPDesktopAggregationVariant: Boolean = false
        $followSearchTypes: [types] = [SEARCH, USER_PREFERENCE]
        $mlType: MlType
        $similarItemsCount: Int!
        $skipSponsoredItems: Boolean = true
        $isEstimateSimilarSoldVariant: Boolean = false
    ) {
        viewer {
            ...PdpHeadBuilder_viewer
            ...PdpRespMarketplaceLayoutPrimary_viewer
            # eslint-disable-next-line relay/unused-fields
            itemRead(itemIds: $itemIds) {
                ... on Item {
                    ...PdpHeadBuilder_item
                    ...handlePdpStatuses_item
                }
                ...findPdpItemReadError_itemRead
            }
        }
    }
`;
